import {div} from '@xh/hoist/cmp/layout';
import classNames from 'classnames';
import {ReactElement} from 'react';
import type {NavModeType} from '../../RzxApp';
import type {UiStyle} from '../UiStyle';
import './AppOptionPreviews.scss';

const base = 'rzx-app-preview';

/** A mini app window with its tabs along the top, or a side rail of nav icons. */
export function navModePreview(mode: NavModeType): ReactElement {
    const isTabs = mode === 'tabs';
    return div({
        className: classNames(base, `${base}--${mode}`),
        items: [
            isTabs ? div({className: `${base}__appbar`, items: [0, 1, 2].map(i => div({key: i, className: `${base}__tab`}))}) : null,
            div({
                className: `${base}__body`,
                items: [isTabs ? null : div({className: `${base}__rail`, items: [0, 1, 2].map(i => div({key: i, className: `${base}__rail-item`}))}), content()]
            })
        ]
    });
}

/** A mini app window with, or without, the scrolling ticker tape along its bottom edge. */
export function tickerTapePreview(show: boolean): ReactElement {
    return div({
        className: base,
        items: [
            div({className: `${base}__body`, item: content()}),
            show ? div({className: `${base}__tape`, items: [0, 1, 2, 3].map(i => div({key: i, className: `${base}__tick`}))}) : null
        ]
    });
}

/**
 * A mini quote grid in the given display style. Standard shows colored text, drawn as thin colored
 * lines. Terminal shows denser rows with solid colored cells.
 */
export function uiStylePreview(style: UiStyle): ReactElement {
    const dirs = style === 'terminal' ? ['up', 'down', 'up', 'up', 'down'] : ['up', 'down', 'up', 'down'];
    return div({
        className: classNames(base, `${base}--${style}`),
        items: dirs.map((dir, i) =>
            div({
                key: i,
                className: `${base}__quote-row ${base}__quote-row--${dir}`,
                items: [div({className: `${base}__quote-sym`}), div({className: `${base}__quote-val`}), div({className: `${base}__quote-chg`})]
            })
        )
    });
}

function content() {
    return div({
        className: `${base}__content`,
        items: [div({className: `${base}__accent`}), div({className: `${base}__line`}), div({className: `${base}__line ${base}__line--short`})]
    });
}
